import { render, staticRenderFns } from "./driverRoyaltyWage.vue?vue&type=template&id=72564c2b&scoped=true"
import script from "./driverRoyaltyWage.vue?vue&type=script&lang=js"
export * from "./driverRoyaltyWage.vue?vue&type=script&lang=js"
import style0 from "./driverRoyaltyWage.vue?vue&type=style&index=0&id=72564c2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72564c2b",
  null
  
)

export default component.exports